"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/loans/v1/loans.proto
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoansServiceClient = exports.RepaymentSummaryEvent = exports.MangopayInflowOutflowUnblockedEvent = exports.RepaymentEvent = exports.FPFReport = exports.FPFStatsResponse_YearToReportEntry = exports.FPFStatsResponse = exports.FPFStatsRequest = exports.ComposeLoanPlanResponse_LenderPlansEntry = exports.ComposeLoanPlanResponse = exports.ComposeLoanPlanRequest = exports.RateLimit = exports.ComputeXIRRRequest = exports.ComputeXIRRResponse = exports.XIRRLine = exports.ComputeDatedLoanPlansRequest = exports.LenderLoanPlan = exports.ComputeDatedLoanPlansResponse_LenderPlansEntry = exports.ComputeDatedLoanPlansResponse = exports.ComputeLoanPlanFeesParameters = exports.ComputeLoanPlanParameters = exports.ComputeLoanPlanRequest = exports.LoanPlanTerm = exports.BorrowerAggregate = exports.ComputeLoanPlanResponse = exports.SimulateInterestsResponse = exports.SimulateInterestsRequest = exports.RepayTermRepayResponse = exports.RepayTermRepayRequest = exports.mangopayInflowOutflowUnblockedEvent_DirectionToJSON = exports.mangopayInflowOutflowUnblockedEvent_DirectionFromJSON = exports.MangopayInflowOutflowUnblockedEvent_Direction = void 0;
/* eslint-disable */
var health_1 = require("../../common/v1/health");
var term_frequency_1 = require("../../common/v1/term_frequency");
exports.MangopayInflowOutflowUnblockedEvent_Direction = {
    DIRECTION_UNSPECIFIED: "DIRECTION_UNSPECIFIED",
    DIRECTION_INFLOW: "DIRECTION_INFLOW",
    DIRECTION_OUTFLOW: "DIRECTION_OUTFLOW",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function mangopayInflowOutflowUnblockedEvent_DirectionFromJSON(object) {
    switch (object) {
        case 0:
        case "DIRECTION_UNSPECIFIED":
            return exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_UNSPECIFIED;
        case 1:
        case "DIRECTION_INFLOW":
            return exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_INFLOW;
        case 2:
        case "DIRECTION_OUTFLOW":
            return exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_OUTFLOW;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.MangopayInflowOutflowUnblockedEvent_Direction.UNRECOGNIZED;
    }
}
exports.mangopayInflowOutflowUnblockedEvent_DirectionFromJSON = mangopayInflowOutflowUnblockedEvent_DirectionFromJSON;
function mangopayInflowOutflowUnblockedEvent_DirectionToJSON(object) {
    switch (object) {
        case exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_UNSPECIFIED:
            return "DIRECTION_UNSPECIFIED";
        case exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_INFLOW:
            return "DIRECTION_INFLOW";
        case exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_OUTFLOW:
            return "DIRECTION_OUTFLOW";
        case exports.MangopayInflowOutflowUnblockedEvent_Direction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.mangopayInflowOutflowUnblockedEvent_DirectionToJSON = mangopayInflowOutflowUnblockedEvent_DirectionToJSON;
function createBaseRepayTermRepayRequest() {
    return { id: 0 };
}
exports.RepayTermRepayRequest = {
    fromJSON: function (object) {
        return { id: isSet(object.id) ? globalThis.Number(object.id) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermRepayRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseRepayTermRepayRequest();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseRepayTermRepayResponse() {
    return { rate_limit: undefined };
}
exports.RepayTermRepayResponse = {
    fromJSON: function (object) {
        return { rate_limit: isSet(object.rate_limit) ? exports.RateLimit.fromJSON(object.rate_limit) : undefined };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.rate_limit !== undefined) {
            obj.rate_limit = exports.RateLimit.toJSON(message.rate_limit);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepayTermRepayResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var message = createBaseRepayTermRepayResponse();
        message.rate_limit = (object.rate_limit !== undefined && object.rate_limit !== null)
            ? exports.RateLimit.fromPartial(object.rate_limit)
            : undefined;
        return message;
    },
};
function createBaseSimulateInterestsRequest() {
    return { project_slug: "", amount: 0 };
}
exports.SimulateInterestsRequest = {
    fromJSON: function (object) {
        return {
            project_slug: isSet(object.project_slug) ? globalThis.String(object.project_slug) : "",
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.project_slug !== "") {
            obj.project_slug = message.project_slug;
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.SimulateInterestsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseSimulateInterestsRequest();
        message.project_slug = (_a = object.project_slug) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseSimulateInterestsResponse() {
    return { capital: 0, interests: 0 };
}
exports.SimulateInterestsResponse = {
    fromJSON: function (object) {
        return {
            capital: isSet(object.capital) ? globalThis.Number(object.capital) : 0,
            interests: isSet(object.interests) ? globalThis.Number(object.interests) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.capital !== 0) {
            obj.capital = Math.round(message.capital);
        }
        if (message.interests !== 0) {
            obj.interests = Math.round(message.interests);
        }
        return obj;
    },
    create: function (base) {
        return exports.SimulateInterestsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseSimulateInterestsResponse();
        message.capital = (_a = object.capital) !== null && _a !== void 0 ? _a : 0;
        message.interests = (_b = object.interests) !== null && _b !== void 0 ? _b : 0;
        return message;
    },
};
function createBaseComputeLoanPlanResponse() {
    return { term_plan: [], borrower_aggregate: undefined };
}
exports.ComputeLoanPlanResponse = {
    fromJSON: function (object) {
        return {
            term_plan: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.term_plan)
                ? object.term_plan.map(function (e) { return exports.LoanPlanTerm.fromJSON(e); })
                : [],
            borrower_aggregate: isSet(object.borrower_aggregate)
                ? exports.BorrowerAggregate.fromJSON(object.borrower_aggregate)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.term_plan) === null || _a === void 0 ? void 0 : _a.length) {
            obj.term_plan = message.term_plan.map(function (e) { return exports.LoanPlanTerm.toJSON(e); });
        }
        if (message.borrower_aggregate !== undefined) {
            obj.borrower_aggregate = exports.BorrowerAggregate.toJSON(message.borrower_aggregate);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeLoanPlanResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseComputeLoanPlanResponse();
        message.term_plan = ((_a = object.term_plan) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LoanPlanTerm.fromPartial(e); })) || [];
        message.borrower_aggregate = (object.borrower_aggregate !== undefined && object.borrower_aggregate !== null)
            ? exports.BorrowerAggregate.fromPartial(object.borrower_aggregate)
            : undefined;
        return message;
    },
};
function createBaseBorrowerAggregate() {
    return {
        front_fees_amount: 0,
        term_amount: 0,
        term_fees_amount: 0,
        internal_rate_of_return: 0,
        total_interest_amount: 0,
        total_cost_amount: 0,
    };
}
exports.BorrowerAggregate = {
    fromJSON: function (object) {
        return {
            front_fees_amount: isSet(object.front_fees_amount) ? globalThis.Number(object.front_fees_amount) : 0,
            term_amount: isSet(object.term_amount) ? globalThis.Number(object.term_amount) : 0,
            term_fees_amount: isSet(object.term_fees_amount) ? globalThis.Number(object.term_fees_amount) : 0,
            internal_rate_of_return: isSet(object.internal_rate_of_return)
                ? globalThis.Number(object.internal_rate_of_return)
                : 0,
            total_interest_amount: isSet(object.total_interest_amount) ? globalThis.Number(object.total_interest_amount) : 0,
            total_cost_amount: isSet(object.total_cost_amount) ? globalThis.Number(object.total_cost_amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.front_fees_amount !== 0) {
            obj.front_fees_amount = Math.round(message.front_fees_amount);
        }
        if (message.term_amount !== 0) {
            obj.term_amount = Math.round(message.term_amount);
        }
        if (message.term_fees_amount !== 0) {
            obj.term_fees_amount = Math.round(message.term_fees_amount);
        }
        if (message.internal_rate_of_return !== 0) {
            obj.internal_rate_of_return = message.internal_rate_of_return;
        }
        if (message.total_interest_amount !== 0) {
            obj.total_interest_amount = Math.round(message.total_interest_amount);
        }
        if (message.total_cost_amount !== 0) {
            obj.total_cost_amount = Math.round(message.total_cost_amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.BorrowerAggregate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f;
        var message = createBaseBorrowerAggregate();
        message.front_fees_amount = (_a = object.front_fees_amount) !== null && _a !== void 0 ? _a : 0;
        message.term_amount = (_b = object.term_amount) !== null && _b !== void 0 ? _b : 0;
        message.term_fees_amount = (_c = object.term_fees_amount) !== null && _c !== void 0 ? _c : 0;
        message.internal_rate_of_return = (_d = object.internal_rate_of_return) !== null && _d !== void 0 ? _d : 0;
        message.total_interest_amount = (_e = object.total_interest_amount) !== null && _e !== void 0 ? _e : 0;
        message.total_cost_amount = (_f = object.total_cost_amount) !== null && _f !== void 0 ? _f : 0;
        return message;
    },
};
function createBaseLoanPlanTerm() {
    return {
        index: 0,
        amount: 0,
        amortized_capital_amount: 0,
        interest_amount: 0,
        capital_amount: 0,
        outstanding_capital_amount: 0,
        intercallary_interest_amount: 0,
        net_fees_amount: 0,
        vat_fees_amount: 0,
        scheduled_at: "",
    };
}
exports.LoanPlanTerm = {
    fromJSON: function (object) {
        return {
            index: isSet(object.index) ? globalThis.Number(object.index) : 0,
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            amortized_capital_amount: isSet(object.amortized_capital_amount)
                ? globalThis.Number(object.amortized_capital_amount)
                : 0,
            interest_amount: isSet(object.interest_amount) ? globalThis.Number(object.interest_amount) : 0,
            capital_amount: isSet(object.capital_amount) ? globalThis.Number(object.capital_amount) : 0,
            outstanding_capital_amount: isSet(object.outstanding_capital_amount)
                ? globalThis.Number(object.outstanding_capital_amount)
                : 0,
            intercallary_interest_amount: isSet(object.intercallary_interest_amount)
                ? globalThis.Number(object.intercallary_interest_amount)
                : 0,
            net_fees_amount: isSet(object.net_fees_amount) ? globalThis.Number(object.net_fees_amount) : 0,
            vat_fees_amount: isSet(object.vat_fees_amount) ? globalThis.Number(object.vat_fees_amount) : 0,
            scheduled_at: isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.index !== 0) {
            obj.index = Math.round(message.index);
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if (message.amortized_capital_amount !== 0) {
            obj.amortized_capital_amount = Math.round(message.amortized_capital_amount);
        }
        if (message.interest_amount !== 0) {
            obj.interest_amount = Math.round(message.interest_amount);
        }
        if (message.capital_amount !== 0) {
            obj.capital_amount = Math.round(message.capital_amount);
        }
        if (message.outstanding_capital_amount !== 0) {
            obj.outstanding_capital_amount = Math.round(message.outstanding_capital_amount);
        }
        if (message.intercallary_interest_amount !== 0) {
            obj.intercallary_interest_amount = Math.round(message.intercallary_interest_amount);
        }
        if (message.net_fees_amount !== 0) {
            obj.net_fees_amount = Math.round(message.net_fees_amount);
        }
        if (message.vat_fees_amount !== 0) {
            obj.vat_fees_amount = Math.round(message.vat_fees_amount);
        }
        if (message.scheduled_at !== "") {
            obj.scheduled_at = message.scheduled_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.LoanPlanTerm.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var message = createBaseLoanPlanTerm();
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : 0;
        message.amortized_capital_amount = (_c = object.amortized_capital_amount) !== null && _c !== void 0 ? _c : 0;
        message.interest_amount = (_d = object.interest_amount) !== null && _d !== void 0 ? _d : 0;
        message.capital_amount = (_e = object.capital_amount) !== null && _e !== void 0 ? _e : 0;
        message.outstanding_capital_amount = (_f = object.outstanding_capital_amount) !== null && _f !== void 0 ? _f : 0;
        message.intercallary_interest_amount = (_g = object.intercallary_interest_amount) !== null && _g !== void 0 ? _g : 0;
        message.net_fees_amount = (_h = object.net_fees_amount) !== null && _h !== void 0 ? _h : 0;
        message.vat_fees_amount = (_j = object.vat_fees_amount) !== null && _j !== void 0 ? _j : 0;
        message.scheduled_at = (_k = object.scheduled_at) !== null && _k !== void 0 ? _k : "";
        return message;
    },
};
function createBaseComputeLoanPlanRequest() {
    return { loan_plan_params: undefined, loan_plan_fees_params: undefined, amount: 0 };
}
exports.ComputeLoanPlanRequest = {
    fromJSON: function (object) {
        return {
            loan_plan_params: isSet(object.loan_plan_params)
                ? exports.ComputeLoanPlanParameters.fromJSON(object.loan_plan_params)
                : undefined,
            loan_plan_fees_params: isSet(object.loan_plan_fees_params)
                ? exports.ComputeLoanPlanFeesParameters.fromJSON(object.loan_plan_fees_params)
                : undefined,
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.loan_plan_params !== undefined) {
            obj.loan_plan_params = exports.ComputeLoanPlanParameters.toJSON(message.loan_plan_params);
        }
        if (message.loan_plan_fees_params !== undefined) {
            obj.loan_plan_fees_params = exports.ComputeLoanPlanFeesParameters.toJSON(message.loan_plan_fees_params);
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeLoanPlanRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseComputeLoanPlanRequest();
        message.loan_plan_params = (object.loan_plan_params !== undefined && object.loan_plan_params !== null)
            ? exports.ComputeLoanPlanParameters.fromPartial(object.loan_plan_params)
            : undefined;
        message.loan_plan_fees_params =
            (object.loan_plan_fees_params !== undefined && object.loan_plan_fees_params !== null)
                ? exports.ComputeLoanPlanFeesParameters.fromPartial(object.loan_plan_fees_params)
                : undefined;
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseComputeLoanPlanParameters() {
    return {
        terms_count: 0,
        delayed_amortization_terms_count: 0,
        delayed_repayment_terms_count: 0,
        annual_interest_ratio: 0,
        term_frequency: term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
        with_borrower_aggregate: false,
        amortizing_type: term_frequency_1.AmortizingType.AMORTIZING_TYPE_UNSPECIFIED,
    };
}
exports.ComputeLoanPlanParameters = {
    fromJSON: function (object) {
        return {
            terms_count: isSet(object.terms_count) ? globalThis.Number(object.terms_count) : 0,
            delayed_amortization_terms_count: isSet(object.delayed_amortization_terms_count)
                ? globalThis.Number(object.delayed_amortization_terms_count)
                : 0,
            delayed_repayment_terms_count: isSet(object.delayed_repayment_terms_count)
                ? globalThis.Number(object.delayed_repayment_terms_count)
                : 0,
            annual_interest_ratio: isSet(object.annual_interest_ratio) ? globalThis.Number(object.annual_interest_ratio) : 0,
            term_frequency: isSet(object.term_frequency)
                ? (0, term_frequency_1.termFrequencyFromJSON)(object.term_frequency)
                : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED,
            with_borrower_aggregate: isSet(object.with_borrower_aggregate)
                ? globalThis.Boolean(object.with_borrower_aggregate)
                : false,
            amortizing_type: isSet(object.amortizing_type)
                ? (0, term_frequency_1.amortizingTypeFromJSON)(object.amortizing_type)
                : term_frequency_1.AmortizingType.AMORTIZING_TYPE_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.terms_count !== 0) {
            obj.terms_count = Math.round(message.terms_count);
        }
        if (message.delayed_amortization_terms_count !== 0) {
            obj.delayed_amortization_terms_count = Math.round(message.delayed_amortization_terms_count);
        }
        if (message.delayed_repayment_terms_count !== 0) {
            obj.delayed_repayment_terms_count = Math.round(message.delayed_repayment_terms_count);
        }
        if (message.annual_interest_ratio !== 0) {
            obj.annual_interest_ratio = message.annual_interest_ratio;
        }
        if (message.term_frequency !== term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED) {
            obj.term_frequency = (0, term_frequency_1.termFrequencyToJSON)(message.term_frequency);
        }
        if (message.with_borrower_aggregate !== false) {
            obj.with_borrower_aggregate = message.with_borrower_aggregate;
        }
        if (message.amortizing_type !== term_frequency_1.AmortizingType.AMORTIZING_TYPE_UNSPECIFIED) {
            obj.amortizing_type = (0, term_frequency_1.amortizingTypeToJSON)(message.amortizing_type);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeLoanPlanParameters.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        var message = createBaseComputeLoanPlanParameters();
        message.terms_count = (_a = object.terms_count) !== null && _a !== void 0 ? _a : 0;
        message.delayed_amortization_terms_count = (_b = object.delayed_amortization_terms_count) !== null && _b !== void 0 ? _b : 0;
        message.delayed_repayment_terms_count = (_c = object.delayed_repayment_terms_count) !== null && _c !== void 0 ? _c : 0;
        message.annual_interest_ratio = (_d = object.annual_interest_ratio) !== null && _d !== void 0 ? _d : 0;
        message.term_frequency = (_e = object.term_frequency) !== null && _e !== void 0 ? _e : term_frequency_1.TermFrequency.TERM_FREQUENCY_UNSPECIFIED;
        message.with_borrower_aggregate = (_f = object.with_borrower_aggregate) !== null && _f !== void 0 ? _f : false;
        message.amortizing_type = (_g = object.amortizing_type) !== null && _g !== void 0 ? _g : term_frequency_1.AmortizingType.AMORTIZING_TYPE_UNSPECIFIED;
        return message;
    },
};
function createBaseComputeLoanPlanFeesParameters() {
    return { annual_term_fees_ratio: 0, front_fees_ratio: 0, vat_ratio: 0 };
}
exports.ComputeLoanPlanFeesParameters = {
    fromJSON: function (object) {
        return {
            annual_term_fees_ratio: isSet(object.annual_term_fees_ratio)
                ? globalThis.Number(object.annual_term_fees_ratio)
                : 0,
            front_fees_ratio: isSet(object.front_fees_ratio) ? globalThis.Number(object.front_fees_ratio) : 0,
            vat_ratio: isSet(object.vat_ratio) ? globalThis.Number(object.vat_ratio) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.annual_term_fees_ratio !== 0) {
            obj.annual_term_fees_ratio = message.annual_term_fees_ratio;
        }
        if (message.front_fees_ratio !== 0) {
            obj.front_fees_ratio = message.front_fees_ratio;
        }
        if (message.vat_ratio !== 0) {
            obj.vat_ratio = message.vat_ratio;
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeLoanPlanFeesParameters.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseComputeLoanPlanFeesParameters();
        message.annual_term_fees_ratio = (_a = object.annual_term_fees_ratio) !== null && _a !== void 0 ? _a : 0;
        message.front_fees_ratio = (_b = object.front_fees_ratio) !== null && _b !== void 0 ? _b : 0;
        message.vat_ratio = (_c = object.vat_ratio) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function createBaseComputeDatedLoanPlansResponse() {
    return { borrower_plan: [], lender_plans: {}, borrower_aggregate: undefined };
}
exports.ComputeDatedLoanPlansResponse = {
    fromJSON: function (object) {
        return {
            borrower_plan: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.borrower_plan)
                ? object.borrower_plan.map(function (e) { return exports.LoanPlanTerm.fromJSON(e); })
                : [],
            lender_plans: isObject(object.lender_plans)
                ? Object.entries(object.lender_plans).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[globalThis.Number(key)] = exports.LenderLoanPlan.fromJSON(value);
                    return acc;
                }, {})
                : {},
            borrower_aggregate: isSet(object.borrower_aggregate)
                ? exports.BorrowerAggregate.fromJSON(object.borrower_aggregate)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.borrower_plan) === null || _a === void 0 ? void 0 : _a.length) {
            obj.borrower_plan = message.borrower_plan.map(function (e) { return exports.LoanPlanTerm.toJSON(e); });
        }
        if (message.lender_plans) {
            var entries = Object.entries(message.lender_plans);
            if (entries.length > 0) {
                obj.lender_plans = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.lender_plans[k] = exports.LenderLoanPlan.toJSON(v);
                });
            }
        }
        if (message.borrower_aggregate !== undefined) {
            obj.borrower_aggregate = exports.BorrowerAggregate.toJSON(message.borrower_aggregate);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeDatedLoanPlansResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseComputeDatedLoanPlansResponse();
        message.borrower_plan = ((_a = object.borrower_plan) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LoanPlanTerm.fromPartial(e); })) || [];
        message.lender_plans = Object.entries((_b = object.lender_plans) !== null && _b !== void 0 ? _b : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[globalThis.Number(key)] = exports.LenderLoanPlan.fromPartial(value);
            }
            return acc;
        }, {});
        message.borrower_aggregate = (object.borrower_aggregate !== undefined && object.borrower_aggregate !== null)
            ? exports.BorrowerAggregate.fromPartial(object.borrower_aggregate)
            : undefined;
        return message;
    },
};
function createBaseComputeDatedLoanPlansResponse_LenderPlansEntry() {
    return { key: 0, value: undefined };
}
exports.ComputeDatedLoanPlansResponse_LenderPlansEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.Number(object.key) : 0,
            value: isSet(object.value) ? exports.LenderLoanPlan.fromJSON(object.value) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== 0) {
            obj.key = Math.round(message.key);
        }
        if (message.value !== undefined) {
            obj.value = exports.LenderLoanPlan.toJSON(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeDatedLoanPlansResponse_LenderPlansEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseComputeDatedLoanPlansResponse_LenderPlansEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : 0;
        message.value = (object.value !== undefined && object.value !== null)
            ? exports.LenderLoanPlan.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseLenderLoanPlan() {
    return { lender_loan_plan_terms: [] };
}
exports.LenderLoanPlan = {
    fromJSON: function (object) {
        return {
            lender_loan_plan_terms: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.lender_loan_plan_terms)
                ? object.lender_loan_plan_terms.map(function (e) { return exports.LoanPlanTerm.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.lender_loan_plan_terms) === null || _a === void 0 ? void 0 : _a.length) {
            obj.lender_loan_plan_terms = message.lender_loan_plan_terms.map(function (e) { return exports.LoanPlanTerm.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.LenderLoanPlan.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseLenderLoanPlan();
        message.lender_loan_plan_terms = ((_a = object.lender_loan_plan_terms) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LoanPlanTerm.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseComputeDatedLoanPlansRequest() {
    return {
        loan_plan_params: undefined,
        loan_plan_fees_params: undefined,
        borrower_amount: 0,
        lender_amounts: [],
        loan_created_at: "",
        credit_starts_at: "",
    };
}
exports.ComputeDatedLoanPlansRequest = {
    fromJSON: function (object) {
        return {
            loan_plan_params: isSet(object.loan_plan_params)
                ? exports.ComputeLoanPlanParameters.fromJSON(object.loan_plan_params)
                : undefined,
            loan_plan_fees_params: isSet(object.loan_plan_fees_params)
                ? exports.ComputeLoanPlanFeesParameters.fromJSON(object.loan_plan_fees_params)
                : undefined,
            borrower_amount: isSet(object.borrower_amount) ? globalThis.Number(object.borrower_amount) : 0,
            lender_amounts: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.lender_amounts)
                ? object.lender_amounts.map(function (e) { return globalThis.Number(e); })
                : [],
            loan_created_at: isSet(object.loan_created_at) ? globalThis.String(object.loan_created_at) : "",
            credit_starts_at: isSet(object.credit_starts_at) ? globalThis.String(object.credit_starts_at) : "",
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.loan_plan_params !== undefined) {
            obj.loan_plan_params = exports.ComputeLoanPlanParameters.toJSON(message.loan_plan_params);
        }
        if (message.loan_plan_fees_params !== undefined) {
            obj.loan_plan_fees_params = exports.ComputeLoanPlanFeesParameters.toJSON(message.loan_plan_fees_params);
        }
        if (message.borrower_amount !== 0) {
            obj.borrower_amount = Math.round(message.borrower_amount);
        }
        if ((_a = message.lender_amounts) === null || _a === void 0 ? void 0 : _a.length) {
            obj.lender_amounts = message.lender_amounts.map(function (e) { return Math.round(e); });
        }
        if (message.loan_created_at !== "") {
            obj.loan_created_at = message.loan_created_at;
        }
        if (message.credit_starts_at !== "") {
            obj.credit_starts_at = message.credit_starts_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeDatedLoanPlansRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseComputeDatedLoanPlansRequest();
        message.loan_plan_params = (object.loan_plan_params !== undefined && object.loan_plan_params !== null)
            ? exports.ComputeLoanPlanParameters.fromPartial(object.loan_plan_params)
            : undefined;
        message.loan_plan_fees_params =
            (object.loan_plan_fees_params !== undefined && object.loan_plan_fees_params !== null)
                ? exports.ComputeLoanPlanFeesParameters.fromPartial(object.loan_plan_fees_params)
                : undefined;
        message.borrower_amount = (_a = object.borrower_amount) !== null && _a !== void 0 ? _a : 0;
        message.lender_amounts = ((_b = object.lender_amounts) === null || _b === void 0 ? void 0 : _b.map(function (e) { return e; })) || [];
        message.loan_created_at = (_c = object.loan_created_at) !== null && _c !== void 0 ? _c : "";
        message.credit_starts_at = (_d = object.credit_starts_at) !== null && _d !== void 0 ? _d : "";
        return message;
    },
};
function createBaseXIRRLine() {
    return { amount: 0, date: "" };
}
exports.XIRRLine = {
    fromJSON: function (object) {
        return {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            date: isSet(object.date) ? globalThis.String(object.date) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = message.amount;
        }
        if (message.date !== "") {
            obj.date = message.date;
        }
        return obj;
    },
    create: function (base) {
        return exports.XIRRLine.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseXIRRLine();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        message.date = (_b = object.date) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseComputeXIRRResponse() {
    return { xirr: 0 };
}
exports.ComputeXIRRResponse = {
    fromJSON: function (object) {
        return { xirr: isSet(object.xirr) ? globalThis.Number(object.xirr) : 0 };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.xirr !== 0) {
            obj.xirr = message.xirr;
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeXIRRResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseComputeXIRRResponse();
        message.xirr = (_a = object.xirr) !== null && _a !== void 0 ? _a : 0;
        return message;
    },
};
function createBaseComputeXIRRRequest() {
    return { transactions: [] };
}
exports.ComputeXIRRRequest = {
    fromJSON: function (object) {
        return {
            transactions: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.transactions)
                ? object.transactions.map(function (e) { return exports.XIRRLine.fromJSON(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.transactions) === null || _a === void 0 ? void 0 : _a.length) {
            obj.transactions = message.transactions.map(function (e) { return exports.XIRRLine.toJSON(e); });
        }
        return obj;
    },
    create: function (base) {
        return exports.ComputeXIRRRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseComputeXIRRRequest();
        message.transactions = ((_a = object.transactions) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.XIRRLine.fromPartial(e); })) || [];
        return message;
    },
};
function createBaseRateLimit() {
    return { limit: [], remaining: [], reset_time: [] };
}
exports.RateLimit = {
    fromJSON: function (object) {
        return {
            limit: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.limit) ? object.limit.map(function (e) { return globalThis.String(e); }) : [],
            remaining: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.remaining)
                ? object.remaining.map(function (e) { return globalThis.String(e); })
                : [],
            reset_time: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.reset_time)
                ? object.reset_time.map(function (e) { return globalThis.String(e); })
                : [],
        };
    },
    toJSON: function (message) {
        var _a, _b, _c;
        var obj = {};
        if ((_a = message.limit) === null || _a === void 0 ? void 0 : _a.length) {
            obj.limit = message.limit;
        }
        if ((_b = message.remaining) === null || _b === void 0 ? void 0 : _b.length) {
            obj.remaining = message.remaining;
        }
        if ((_c = message.reset_time) === null || _c === void 0 ? void 0 : _c.length) {
            obj.reset_time = message.reset_time;
        }
        return obj;
    },
    create: function (base) {
        return exports.RateLimit.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseRateLimit();
        message.limit = ((_a = object.limit) === null || _a === void 0 ? void 0 : _a.map(function (e) { return e; })) || [];
        message.remaining = ((_b = object.remaining) === null || _b === void 0 ? void 0 : _b.map(function (e) { return e; })) || [];
        message.reset_time = ((_c = object.reset_time) === null || _c === void 0 ? void 0 : _c.map(function (e) { return e; })) || [];
        return message;
    },
};
function createBaseComposeLoanPlanRequest() {
    return {
        amount: 0,
        loan_plans: [],
        lender_amounts: [],
        net_term_fees_amount: undefined,
        credit_starts_at: "",
        extra_interest_amount: undefined,
        net_extra_fees_amount: undefined,
    };
}
exports.ComposeLoanPlanRequest = {
    fromJSON: function (object) {
        return {
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            loan_plans: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.loan_plans)
                ? object.loan_plans.map(function (e) { return exports.ComputeLoanPlanRequest.fromJSON(e); })
                : [],
            lender_amounts: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.lender_amounts)
                ? object.lender_amounts.map(function (e) { return globalThis.Number(e); })
                : [],
            net_term_fees_amount: isSet(object.net_term_fees_amount)
                ? globalThis.Number(object.net_term_fees_amount)
                : undefined,
            credit_starts_at: isSet(object.credit_starts_at) ? globalThis.String(object.credit_starts_at) : "",
            extra_interest_amount: isSet(object.extra_interest_amount)
                ? globalThis.Number(object.extra_interest_amount)
                : undefined,
            net_extra_fees_amount: isSet(object.net_extra_fees_amount)
                ? globalThis.Number(object.net_extra_fees_amount)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a, _b;
        var obj = {};
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if ((_a = message.loan_plans) === null || _a === void 0 ? void 0 : _a.length) {
            obj.loan_plans = message.loan_plans.map(function (e) { return exports.ComputeLoanPlanRequest.toJSON(e); });
        }
        if ((_b = message.lender_amounts) === null || _b === void 0 ? void 0 : _b.length) {
            obj.lender_amounts = message.lender_amounts.map(function (e) { return Math.round(e); });
        }
        if (message.net_term_fees_amount !== undefined) {
            obj.net_term_fees_amount = Math.round(message.net_term_fees_amount);
        }
        if (message.credit_starts_at !== "") {
            obj.credit_starts_at = message.credit_starts_at;
        }
        if (message.extra_interest_amount !== undefined) {
            obj.extra_interest_amount = Math.round(message.extra_interest_amount);
        }
        if (message.net_extra_fees_amount !== undefined) {
            obj.net_extra_fees_amount = Math.round(message.net_extra_fees_amount);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComposeLoanPlanRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        var message = createBaseComposeLoanPlanRequest();
        message.amount = (_a = object.amount) !== null && _a !== void 0 ? _a : 0;
        message.loan_plans = ((_b = object.loan_plans) === null || _b === void 0 ? void 0 : _b.map(function (e) { return exports.ComputeLoanPlanRequest.fromPartial(e); })) || [];
        message.lender_amounts = ((_c = object.lender_amounts) === null || _c === void 0 ? void 0 : _c.map(function (e) { return e; })) || [];
        message.net_term_fees_amount = (_d = object.net_term_fees_amount) !== null && _d !== void 0 ? _d : undefined;
        message.credit_starts_at = (_e = object.credit_starts_at) !== null && _e !== void 0 ? _e : "";
        message.extra_interest_amount = (_f = object.extra_interest_amount) !== null && _f !== void 0 ? _f : undefined;
        message.net_extra_fees_amount = (_g = object.net_extra_fees_amount) !== null && _g !== void 0 ? _g : undefined;
        return message;
    },
};
function createBaseComposeLoanPlanResponse() {
    return { borrower_plan: [], lender_plans: {} };
}
exports.ComposeLoanPlanResponse = {
    fromJSON: function (object) {
        return {
            borrower_plan: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.borrower_plan)
                ? object.borrower_plan.map(function (e) { return exports.LoanPlanTerm.fromJSON(e); })
                : [],
            lender_plans: isObject(object.lender_plans)
                ? Object.entries(object.lender_plans).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[globalThis.Number(key)] = exports.LenderLoanPlan.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if ((_a = message.borrower_plan) === null || _a === void 0 ? void 0 : _a.length) {
            obj.borrower_plan = message.borrower_plan.map(function (e) { return exports.LoanPlanTerm.toJSON(e); });
        }
        if (message.lender_plans) {
            var entries = Object.entries(message.lender_plans);
            if (entries.length > 0) {
                obj.lender_plans = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.lender_plans[k] = exports.LenderLoanPlan.toJSON(v);
                });
            }
        }
        return obj;
    },
    create: function (base) {
        return exports.ComposeLoanPlanResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseComposeLoanPlanResponse();
        message.borrower_plan = ((_a = object.borrower_plan) === null || _a === void 0 ? void 0 : _a.map(function (e) { return exports.LoanPlanTerm.fromPartial(e); })) || [];
        message.lender_plans = Object.entries((_b = object.lender_plans) !== null && _b !== void 0 ? _b : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[globalThis.Number(key)] = exports.LenderLoanPlan.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseComposeLoanPlanResponse_LenderPlansEntry() {
    return { key: 0, value: undefined };
}
exports.ComposeLoanPlanResponse_LenderPlansEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.Number(object.key) : 0,
            value: isSet(object.value) ? exports.LenderLoanPlan.fromJSON(object.value) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== 0) {
            obj.key = Math.round(message.key);
        }
        if (message.value !== undefined) {
            obj.value = exports.LenderLoanPlan.toJSON(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.ComposeLoanPlanResponse_LenderPlansEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseComposeLoanPlanResponse_LenderPlansEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : 0;
        message.value = (object.value !== undefined && object.value !== null)
            ? exports.LenderLoanPlan.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseFPFStatsRequest() {
    return {};
}
exports.FPFStatsRequest = {
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.FPFStatsRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseFPFStatsRequest();
        return message;
    },
};
function createBaseFPFStatsResponse() {
    return { year_to_report: {}, total_report: undefined, generated_at: "" };
}
exports.FPFStatsResponse = {
    fromJSON: function (object) {
        return {
            year_to_report: isObject(object.year_to_report)
                ? Object.entries(object.year_to_report).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    acc[globalThis.Number(key)] = exports.FPFReport.fromJSON(value);
                    return acc;
                }, {})
                : {},
            total_report: isSet(object.total_report) ? exports.FPFReport.fromJSON(object.total_report) : undefined,
            generated_at: isSet(object.generated_at) ? globalThis.String(object.generated_at) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.year_to_report) {
            var entries = Object.entries(message.year_to_report);
            if (entries.length > 0) {
                obj.year_to_report = {};
                entries.forEach(function (_a) {
                    var k = _a[0], v = _a[1];
                    obj.year_to_report[k] = exports.FPFReport.toJSON(v);
                });
            }
        }
        if (message.total_report !== undefined) {
            obj.total_report = exports.FPFReport.toJSON(message.total_report);
        }
        if (message.generated_at !== "") {
            obj.generated_at = message.generated_at;
        }
        return obj;
    },
    create: function (base) {
        return exports.FPFStatsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseFPFStatsResponse();
        message.year_to_report = Object.entries((_a = object.year_to_report) !== null && _a !== void 0 ? _a : {}).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== undefined) {
                acc[globalThis.Number(key)] = exports.FPFReport.fromPartial(value);
            }
            return acc;
        }, {});
        message.total_report = (object.total_report !== undefined && object.total_report !== null)
            ? exports.FPFReport.fromPartial(object.total_report)
            : undefined;
        message.generated_at = (_b = object.generated_at) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseFPFStatsResponse_YearToReportEntry() {
    return { key: 0, value: undefined };
}
exports.FPFStatsResponse_YearToReportEntry = {
    fromJSON: function (object) {
        return {
            key: isSet(object.key) ? globalThis.Number(object.key) : 0,
            value: isSet(object.value) ? exports.FPFReport.fromJSON(object.value) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.key !== 0) {
            obj.key = Math.round(message.key);
        }
        if (message.value !== undefined) {
            obj.value = exports.FPFReport.toJSON(message.value);
        }
        return obj;
    },
    create: function (base) {
        return exports.FPFStatsResponse_YearToReportEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseFPFStatsResponse_YearToReportEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : 0;
        message.value = (object.value !== undefined && object.value !== null)
            ? exports.FPFReport.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseFPFReport() {
    return {
        a: "0",
        b: "0",
        b3: "0",
        c: "0",
        d: 0,
        e: "0",
        f: 0,
        g: "0",
        h: "0",
        i: "0",
        j: "0",
        k: "0",
        l: "0",
        m: "0",
        m2: "0",
        n: "0",
        n2: "0",
        o: "0",
        p: "0",
        p2: "0",
        q: "0",
        q2: "0",
        r: "0",
        s: "0",
        s2: "0",
        t: "0",
        t2: "0",
        u: "0",
        v: "0",
        v2: "0",
        w: "0",
        x: "0",
        y: "0",
        y2: "0",
        z: "0",
        aa: 0,
        ab: 0,
        ac: 0,
        ad: 0,
        ae: 0,
    };
}
exports.FPFReport = {
    fromJSON: function (object) {
        return {
            a: isSet(object.a) ? globalThis.String(object.a) : "0",
            b: isSet(object.b) ? globalThis.String(object.b) : "0",
            b3: isSet(object.b3) ? globalThis.String(object.b3) : "0",
            c: isSet(object.c) ? globalThis.String(object.c) : "0",
            d: isSet(object.d) ? globalThis.Number(object.d) : 0,
            e: isSet(object.e) ? globalThis.String(object.e) : "0",
            f: isSet(object.f) ? globalThis.Number(object.f) : 0,
            g: isSet(object.g) ? globalThis.String(object.g) : "0",
            h: isSet(object.h) ? globalThis.String(object.h) : "0",
            i: isSet(object.i) ? globalThis.String(object.i) : "0",
            j: isSet(object.j) ? globalThis.String(object.j) : "0",
            k: isSet(object.k) ? globalThis.String(object.k) : "0",
            l: isSet(object.l) ? globalThis.String(object.l) : "0",
            m: isSet(object.m) ? globalThis.String(object.m) : "0",
            m2: isSet(object.m2) ? globalThis.String(object.m2) : "0",
            n: isSet(object.n) ? globalThis.String(object.n) : "0",
            n2: isSet(object.n2) ? globalThis.String(object.n2) : "0",
            o: isSet(object.o) ? globalThis.String(object.o) : "0",
            p: isSet(object.p) ? globalThis.String(object.p) : "0",
            p2: isSet(object.p2) ? globalThis.String(object.p2) : "0",
            q: isSet(object.q) ? globalThis.String(object.q) : "0",
            q2: isSet(object.q2) ? globalThis.String(object.q2) : "0",
            r: isSet(object.r) ? globalThis.String(object.r) : "0",
            s: isSet(object.s) ? globalThis.String(object.s) : "0",
            s2: isSet(object.s2) ? globalThis.String(object.s2) : "0",
            t: isSet(object.t) ? globalThis.String(object.t) : "0",
            t2: isSet(object.t2) ? globalThis.String(object.t2) : "0",
            u: isSet(object.u) ? globalThis.String(object.u) : "0",
            v: isSet(object.v) ? globalThis.String(object.v) : "0",
            v2: isSet(object.v2) ? globalThis.String(object.v2) : "0",
            w: isSet(object.w) ? globalThis.String(object.w) : "0",
            x: isSet(object.x) ? globalThis.String(object.x) : "0",
            y: isSet(object.y) ? globalThis.String(object.y) : "0",
            y2: isSet(object.y2) ? globalThis.String(object.y2) : "0",
            z: isSet(object.z) ? globalThis.String(object.z) : "0",
            aa: isSet(object.aa) ? globalThis.Number(object.aa) : 0,
            ab: isSet(object.ab) ? globalThis.Number(object.ab) : 0,
            ac: isSet(object.ac) ? globalThis.Number(object.ac) : 0,
            ad: isSet(object.ad) ? globalThis.Number(object.ad) : 0,
            ae: isSet(object.ae) ? globalThis.Number(object.ae) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.a !== "0") {
            obj.a = message.a;
        }
        if (message.b !== "0") {
            obj.b = message.b;
        }
        if (message.b3 !== "0") {
            obj.b3 = message.b3;
        }
        if (message.c !== "0") {
            obj.c = message.c;
        }
        if (message.d !== 0) {
            obj.d = message.d;
        }
        if (message.e !== "0") {
            obj.e = message.e;
        }
        if (message.f !== 0) {
            obj.f = message.f;
        }
        if (message.g !== "0") {
            obj.g = message.g;
        }
        if (message.h !== "0") {
            obj.h = message.h;
        }
        if (message.i !== "0") {
            obj.i = message.i;
        }
        if (message.j !== "0") {
            obj.j = message.j;
        }
        if (message.k !== "0") {
            obj.k = message.k;
        }
        if (message.l !== "0") {
            obj.l = message.l;
        }
        if (message.m !== "0") {
            obj.m = message.m;
        }
        if (message.m2 !== "0") {
            obj.m2 = message.m2;
        }
        if (message.n !== "0") {
            obj.n = message.n;
        }
        if (message.n2 !== "0") {
            obj.n2 = message.n2;
        }
        if (message.o !== "0") {
            obj.o = message.o;
        }
        if (message.p !== "0") {
            obj.p = message.p;
        }
        if (message.p2 !== "0") {
            obj.p2 = message.p2;
        }
        if (message.q !== "0") {
            obj.q = message.q;
        }
        if (message.q2 !== "0") {
            obj.q2 = message.q2;
        }
        if (message.r !== "0") {
            obj.r = message.r;
        }
        if (message.s !== "0") {
            obj.s = message.s;
        }
        if (message.s2 !== "0") {
            obj.s2 = message.s2;
        }
        if (message.t !== "0") {
            obj.t = message.t;
        }
        if (message.t2 !== "0") {
            obj.t2 = message.t2;
        }
        if (message.u !== "0") {
            obj.u = message.u;
        }
        if (message.v !== "0") {
            obj.v = message.v;
        }
        if (message.v2 !== "0") {
            obj.v2 = message.v2;
        }
        if (message.w !== "0") {
            obj.w = message.w;
        }
        if (message.x !== "0") {
            obj.x = message.x;
        }
        if (message.y !== "0") {
            obj.y = message.y;
        }
        if (message.y2 !== "0") {
            obj.y2 = message.y2;
        }
        if (message.z !== "0") {
            obj.z = message.z;
        }
        if (message.aa !== 0) {
            obj.aa = message.aa;
        }
        if (message.ab !== 0) {
            obj.ab = message.ab;
        }
        if (message.ac !== 0) {
            obj.ac = message.ac;
        }
        if (message.ad !== 0) {
            obj.ad = message.ad;
        }
        if (message.ae !== 0) {
            obj.ae = message.ae;
        }
        return obj;
    },
    create: function (base) {
        return exports.FPFReport.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
        var message = createBaseFPFReport();
        message.a = (_a = object.a) !== null && _a !== void 0 ? _a : "0";
        message.b = (_b = object.b) !== null && _b !== void 0 ? _b : "0";
        message.b3 = (_c = object.b3) !== null && _c !== void 0 ? _c : "0";
        message.c = (_d = object.c) !== null && _d !== void 0 ? _d : "0";
        message.d = (_e = object.d) !== null && _e !== void 0 ? _e : 0;
        message.e = (_f = object.e) !== null && _f !== void 0 ? _f : "0";
        message.f = (_g = object.f) !== null && _g !== void 0 ? _g : 0;
        message.g = (_h = object.g) !== null && _h !== void 0 ? _h : "0";
        message.h = (_j = object.h) !== null && _j !== void 0 ? _j : "0";
        message.i = (_k = object.i) !== null && _k !== void 0 ? _k : "0";
        message.j = (_l = object.j) !== null && _l !== void 0 ? _l : "0";
        message.k = (_m = object.k) !== null && _m !== void 0 ? _m : "0";
        message.l = (_o = object.l) !== null && _o !== void 0 ? _o : "0";
        message.m = (_p = object.m) !== null && _p !== void 0 ? _p : "0";
        message.m2 = (_q = object.m2) !== null && _q !== void 0 ? _q : "0";
        message.n = (_r = object.n) !== null && _r !== void 0 ? _r : "0";
        message.n2 = (_s = object.n2) !== null && _s !== void 0 ? _s : "0";
        message.o = (_t = object.o) !== null && _t !== void 0 ? _t : "0";
        message.p = (_u = object.p) !== null && _u !== void 0 ? _u : "0";
        message.p2 = (_v = object.p2) !== null && _v !== void 0 ? _v : "0";
        message.q = (_w = object.q) !== null && _w !== void 0 ? _w : "0";
        message.q2 = (_x = object.q2) !== null && _x !== void 0 ? _x : "0";
        message.r = (_y = object.r) !== null && _y !== void 0 ? _y : "0";
        message.s = (_z = object.s) !== null && _z !== void 0 ? _z : "0";
        message.s2 = (_0 = object.s2) !== null && _0 !== void 0 ? _0 : "0";
        message.t = (_1 = object.t) !== null && _1 !== void 0 ? _1 : "0";
        message.t2 = (_2 = object.t2) !== null && _2 !== void 0 ? _2 : "0";
        message.u = (_3 = object.u) !== null && _3 !== void 0 ? _3 : "0";
        message.v = (_4 = object.v) !== null && _4 !== void 0 ? _4 : "0";
        message.v2 = (_5 = object.v2) !== null && _5 !== void 0 ? _5 : "0";
        message.w = (_6 = object.w) !== null && _6 !== void 0 ? _6 : "0";
        message.x = (_7 = object.x) !== null && _7 !== void 0 ? _7 : "0";
        message.y = (_8 = object.y) !== null && _8 !== void 0 ? _8 : "0";
        message.y2 = (_9 = object.y2) !== null && _9 !== void 0 ? _9 : "0";
        message.z = (_10 = object.z) !== null && _10 !== void 0 ? _10 : "0";
        message.aa = (_11 = object.aa) !== null && _11 !== void 0 ? _11 : 0;
        message.ab = (_12 = object.ab) !== null && _12 !== void 0 ? _12 : 0;
        message.ac = (_13 = object.ac) !== null && _13 !== void 0 ? _13 : 0;
        message.ad = (_14 = object.ad) !== null && _14 !== void 0 ? _14 : 0;
        message.ae = (_15 = object.ae) !== null && _15 !== void 0 ? _15 : 0;
        return message;
    },
};
function createBaseRepaymentEvent() {
    return {
        debit_term_id: 0,
        repay_term_ids: [],
        process_fees: undefined,
        process_taxes: undefined,
        process_repayment: undefined,
        override_repay_term_idempotency_key: undefined,
    };
}
exports.RepaymentEvent = {
    fromJSON: function (object) {
        return {
            debit_term_id: isSet(object.debit_term_id) ? globalThis.Number(object.debit_term_id) : 0,
            repay_term_ids: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.repay_term_ids)
                ? object.repay_term_ids.map(function (e) { return globalThis.Number(e); })
                : [],
            process_fees: isSet(object.process_fees) ? globalThis.Boolean(object.process_fees) : undefined,
            process_taxes: isSet(object.process_taxes) ? globalThis.Boolean(object.process_taxes) : undefined,
            process_repayment: isSet(object.process_repayment) ? globalThis.Boolean(object.process_repayment) : undefined,
            override_repay_term_idempotency_key: isSet(object.override_repay_term_idempotency_key)
                ? globalThis.String(object.override_repay_term_idempotency_key)
                : undefined,
        };
    },
    toJSON: function (message) {
        var _a;
        var obj = {};
        if (message.debit_term_id !== 0) {
            obj.debit_term_id = Math.round(message.debit_term_id);
        }
        if ((_a = message.repay_term_ids) === null || _a === void 0 ? void 0 : _a.length) {
            obj.repay_term_ids = message.repay_term_ids.map(function (e) { return Math.round(e); });
        }
        if (message.process_fees !== undefined) {
            obj.process_fees = message.process_fees;
        }
        if (message.process_taxes !== undefined) {
            obj.process_taxes = message.process_taxes;
        }
        if (message.process_repayment !== undefined) {
            obj.process_repayment = message.process_repayment;
        }
        if (message.override_repay_term_idempotency_key !== undefined) {
            obj.override_repay_term_idempotency_key = message.override_repay_term_idempotency_key;
        }
        return obj;
    },
    create: function (base) {
        return exports.RepaymentEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d, _e, _f;
        var message = createBaseRepaymentEvent();
        message.debit_term_id = (_a = object.debit_term_id) !== null && _a !== void 0 ? _a : 0;
        message.repay_term_ids = ((_b = object.repay_term_ids) === null || _b === void 0 ? void 0 : _b.map(function (e) { return e; })) || [];
        message.process_fees = (_c = object.process_fees) !== null && _c !== void 0 ? _c : undefined;
        message.process_taxes = (_d = object.process_taxes) !== null && _d !== void 0 ? _d : undefined;
        message.process_repayment = (_e = object.process_repayment) !== null && _e !== void 0 ? _e : undefined;
        message.override_repay_term_idempotency_key = (_f = object.override_repay_term_idempotency_key) !== null && _f !== void 0 ? _f : undefined;
        return message;
    },
};
function createBaseMangopayInflowOutflowUnblockedEvent() {
    return { mangopay_account_id: "", direction: exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_UNSPECIFIED };
}
exports.MangopayInflowOutflowUnblockedEvent = {
    fromJSON: function (object) {
        return {
            mangopay_account_id: isSet(object.mangopay_account_id) ? globalThis.String(object.mangopay_account_id) : "",
            direction: isSet(object.direction)
                ? mangopayInflowOutflowUnblockedEvent_DirectionFromJSON(object.direction)
                : exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_UNSPECIFIED,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.mangopay_account_id !== "") {
            obj.mangopay_account_id = message.mangopay_account_id;
        }
        if (message.direction !== exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_UNSPECIFIED) {
            obj.direction = mangopayInflowOutflowUnblockedEvent_DirectionToJSON(message.direction);
        }
        return obj;
    },
    create: function (base) {
        return exports.MangopayInflowOutflowUnblockedEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMangopayInflowOutflowUnblockedEvent();
        message.mangopay_account_id = (_a = object.mangopay_account_id) !== null && _a !== void 0 ? _a : "";
        message.direction = (_b = object.direction) !== null && _b !== void 0 ? _b : exports.MangopayInflowOutflowUnblockedEvent_Direction.DIRECTION_UNSPECIFIED;
        return message;
    },
};
function createBaseRepaymentSummaryEvent() {
    return { user_id: 0, year: 0, month: 0 };
}
exports.RepaymentSummaryEvent = {
    fromJSON: function (object) {
        return {
            user_id: isSet(object.user_id) ? globalThis.Number(object.user_id) : 0,
            year: isSet(object.year) ? globalThis.Number(object.year) : 0,
            month: isSet(object.month) ? globalThis.Number(object.month) : 0,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.user_id !== 0) {
            obj.user_id = Math.round(message.user_id);
        }
        if (message.year !== 0) {
            obj.year = Math.round(message.year);
        }
        if (message.month !== 0) {
            obj.month = Math.round(message.month);
        }
        return obj;
    },
    create: function (base) {
        return exports.RepaymentSummaryEvent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c;
        var message = createBaseRepaymentSummaryEvent();
        message.user_id = (_a = object.user_id) !== null && _a !== void 0 ? _a : 0;
        message.year = (_b = object.year) !== null && _b !== void 0 ? _b : 0;
        message.month = (_c = object.month) !== null && _c !== void 0 ? _c : 0;
        return message;
    },
};
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
function handleRequest(url, requestBody, fromJSON, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var response, responseBody, parseError_1, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 7, , 8]);
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] request:\n', JSON.stringify(requestBody));
                    }
                    return [4 /*yield*/, fetch(url, {
                            method: 'POST',
                            body: JSON.stringify(requestBody),
                            headers: __assign(__assign({ 'Content-Type': 'application/json' }, ((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : {})), ((options === null || options === void 0 ? void 0 : options.user_id) ? { 'X-Jwt-Payload-B64': options.user_id } : {}))
                        })];
                case 1:
                    response = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.log('[CLIENT DEBUG] response:\n', JSON.stringify(response));
                    }
                    responseBody = void 0;
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 6]);
                    return [4 /*yield*/, response.json()];
                case 3:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 4:
                    parseError_1 = _b.sent();
                    return [4 /*yield*/, response.text()];
                case 5:
                    responseBody = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!response.ok) {
                        throw {
                            statusText: response.statusText || 'HTTP Error',
                            body: responseBody
                        };
                    }
                    return [2 /*return*/, fromJSON(responseBody)];
                case 7:
                    error_1 = _b.sent();
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        console.error('[CLIENT DEBUG] error:\n', JSON.stringify(error_1));
                    }
                    if (error_1.statusText) {
                        // This is our custom error object from above
                        throw error_1;
                    }
                    else {
                        // This could be a network error or other fetch-related error
                        throw {
                            statusText: 'Network Error',
                            body: error_1.message || 'An unknown error occurred',
                            error: error_1,
                        };
                    }
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var LoansServiceClient = /** @class */ (function () {
    function LoansServiceClient(fetcher, baseURL) {
        this.fetcher = fetcher;
        this.baseURL = baseURL;
    }
    LoansServiceClient.prototype.Health = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = health_1.HealthRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/Health";
                return [2 /*return*/, handleRequest(url, jsonReq, health_1.HealthResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.SimulateInterests = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.SimulateInterestsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/SimulateInterests";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.SimulateInterestsResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.ComputeLoanPlan = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ComputeLoanPlanRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/ComputeLoanPlan";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ComputeLoanPlanResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.ComputeDatedLoanPlans = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ComputeDatedLoanPlansRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/ComputeDatedLoanPlans";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ComputeDatedLoanPlansResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.ComputeXIRR = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ComputeXIRRRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/ComputeXIRR";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ComputeXIRRResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.RepayTermRepay = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.RepayTermRepayRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/RepayTermRepay";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.RepayTermRepayResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.ComposeLoanPlan = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.ComposeLoanPlanRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/ComposeLoanPlan";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.ComposeLoanPlanResponse.fromJSON, options)];
            });
        });
    };
    LoansServiceClient.prototype.FPFStats = function (request, options) {
        return __awaiter(this, void 0, void 0, function () {
            var jsonReq, url;
            return __generator(this, function (_a) {
                jsonReq = exports.FPFStatsRequest.toJSON(request);
                url = this.baseURL + "/twirp/miimosa.loans.v1.LoansService/FPFStats";
                return [2 /*return*/, handleRequest(url, jsonReq, exports.FPFStatsResponse.fromJSON, options)];
            });
        });
    };
    return LoansServiceClient;
}());
exports.LoansServiceClient = LoansServiceClient;
//# sourceMappingURL=loans.js.map